import type { ReactNode } from "react";
import { Box, Text } from "@salestrak/ui";
import type { Omittable } from "@salestrak/ui";

type WidgetChartTooltipProps = Omittable<{
  label: ReactNode;
  details: ReactNode | readonly ReactNode[];
  footer?: ReactNode;
}>;

/** Shared chart-tooltip content: a strong category over muted metric details. */
export function WidgetChartTooltip({ label, details, footer }: WidgetChartTooltipProps) {
  const rows = Array.isArray(details) ? details : [details];
  return (
    <Box direction="column" gap="2xs">
      <Text size="xs" weight="semibold">
        {label}
      </Text>
      {rows.map((detail, index) => (
        <Text key={index} size="xs" variant="muted">
          {detail}
        </Text>
      ))}
      {footer != null ? (
        <Text size="xs" weight="medium">
          {footer}
        </Text>
      ) : null}
    </Box>
  );
}
